import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import equal from "fast-deep-equal";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import NextFooter from "components/Next/Footer/NextFooter";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getBlueprintId = (props) =>
  props && props.blueprintId
    ? props.blueprintId
    : props && props.match && props.match.params && props.match.params.blueprintId
      ? props.match.params.blueprintId
      : undefined;

class NextFooterContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    const isEqual = equal(this.props, nextProps);

    return isEqual === true ? false : true;
  }

  render() {
    return <NextFooter {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);

  return {
    saveAsPpt: () => dispatch(nextReducer.saveAsPpt(id)),
    saveNext: (toastText, showToast) => dispatch(nextReducer.saveNext(id, toastText, showToast)),

    changeOutcome: (outcome) => dispatch(homeReducer.changeOutcome(id, outcome)),

    createReport: (label, chart) => dispatch(reportReducer.createReport(label, id, chart)),
    addChartToReport: (reportId, chart) => dispatch(reportReducer.addChartToReport(reportId, id, chart)),
    createLinkedReport: (report) => dispatch(reportReducer.createLinkedReport(report)),

    updateHexSize: (hexSize) => dispatch(nextReducer.updateHexSize(id, hexSize)),
    updateSelectedHex: (hex, node) => dispatch(nextReducer.updateSelectedHex(id, hex, node)),
    updateHexMap: (hexMap) => dispatch(nextReducer.updateHexMap(id, hexMap)),
    updateSavedHexMap: () => dispatch(nextReducer.updateSavedHexMap(id)),
    updatePinnedHex: (hex, node) => dispatch(nextReducer.updatePinnedHex(id, hex, node)),
    updateNodeCompleted: (node) => dispatch(nextReducer.updateNodeCompleted(id, node)),
    updateHover: (node) => dispatch(nextReducer.updateHover(id, node)),
    removeNode: (hex, node) => dispatch(nextReducer.removeNode(id, hex, node)),

    updateChartType: (chartType) => dispatch(nextReducer.updateChartType(id, chartType)),
    updateActiveTab: (activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab)),
    updateIsDistribution: (isDistribution) => dispatch(nextReducer.updateIsDistribution(id, isDistribution)),
    updateReportLabel: (reportLabel) =>
      dispatch(nextReducer.updateReportLabelAndContentGenerationCollection(id, reportLabel)),

    centerHex: (hex, isSmooth) => dispatch(nextReducer.centerHex(hex, isSmooth)),

    replayActions: (node) => dispatch(nextReducer.replayActions(id, node)),
    resetHex: () => dispatch(nextReducer.resetHex(id)),
    resetActions: () => dispatch(nextReducer.resetActions(id)),
    updateIsReplay: (isReplay) => dispatch(nextReducer.updateIsReplay(id, isReplay)),
    updateShowReplay: (showReplay) => dispatch(nextReducer.updateShowReplay(id, showReplay)),
    updateSearchTimeline: (searchValue) => dispatch(nextReducer.updateSearchTimeline(id, searchValue)),

    applySetupStep: (node) => dispatch(nextModelsReducer.applySetupStep(id, node)),
    deleteTodo: (todo) => dispatch(nextModelsReducer.deleteTodo(id, todo)),
    assignTodo: (todo) => dispatch(nextModelsReducer.assignTodo(id, todo)),
    handleUpdate: () => dispatch(nextModelsReducer.handleUpdate(id)),
    modelsUpdateSelectedHex: (node) => dispatch(nextModelsReducer.updateSelectedHexAndSetup(id, node, node)),
    updateIsCommentModal: (isCommentModal) => dispatch(nextModelsReducer.updateIsCommentModal(id, isCommentModal)),

    updateIsGuided: () => dispatch(viewReducer.updateIsGuided(false)),

    deploy: (projectId) => dispatch(projectReducer.deploy(projectId, true)),
    viewScenario: (projectId, scenario, index) => dispatch(projectReducer.viewScenario(projectId, scenario, index)),
    deleteScenario: (projectId) => dispatch(projectReducer.deleteScenario(projectId)),

    saveScenario: (projectId, name) => dispatch(projectReducer.saveScenario(projectId, name)),
    updateSuppressAutoAddReview: (bool) => dispatch(nextModelsReducer.updateSuppressAutoAddReview(id, bool)),
    updateIsOpenSaveModal: (isOpen) => dispatch(nextReducer.updateIsOpenSaveScenarioModal(id, isOpen)),
    updateIsSavingScenario: (isSavingScenario) => dispatch(nextReducer.updateIsSavingScenario(id, isSavingScenario))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);
  const blueprintId = getBlueprintId(ownProps);
  const projectId = nextReducer.getProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const activeTab = nextReducer.getActiveTab(state, id);

  const isReplay =
    activeTab === "MODELS" ? nextModelsReducer.getIsReplay(state, id) : nextReducer.getIsReplay(state, id);

  const hasBeforeReplayHexMap =
    activeTab === "MODELS"
      ? nextModelsReducer.getHasBeforeReplayHexMap(state, id)
      : nextReducer.getHasBeforeReplayHexMap(state, id);

  return {
    id: id,
    datasetId: datasetId,
    projectId: projectId,
    blueprintId: blueprintId,
    runId: runId,

    blueprints: viewReducer.getBlueprints(state),

    dataset: homeReducer.getDataset(state, datasetId),
    rankedFields: homeReducer.getRankedFields(state, datasetId),

    isSavingReport: nextReducer.getIsSavingReport(state, id),
    activeTab: nextReducer.getActiveTab(state, id),
    hexSize: nextReducer.getHexSize(state, id),
    innerHexSize: nextReducer.getInnerHexSize(state, id),
    hexagonRadius: nextReducer.getHexagonRadius(state, id),

    reportLabel: nextReducer.getReportLabel(state, id),
    hexMap: nextReducer.getHexMap(state, id),
    actionHexMap: nextReducer.getActionHexMap(state, id),
    savedHexMap: nextReducer.getSavedHexMap(state, id),

    exploreTodoNodes: nextReducer.getTodoNodes(state, id),
    isOpenSaveModal: nextReducer.getIsOpenSaveScenarioModal(state, id),
    isSavingScenario: nextReducer.getIsSavingScenario(state, id),

    selectedHex: nextReducer.getSelectedHex(state, id),
    timelineSearchOptions: nextReducer.getTimelineSearchOptions(state, id),

    selectedHexModels: nextModelsReducer.getSelectedHex(state, id),

    modelsActionHexMap: nextModelsReducer.getActionHexMap(state, id),
    modelsSavedHexMap: nextModelsReducer.getSavedHexMap(state, id),
    modelTodos: nextModelsReducer.getTodos(state, id),

    isReplay: isReplay,

    visibleActions: nextReducer.getVisibleActions(state, id),
    hasBeforeReplayHexMap: hasBeforeReplayHexMap,
    showReplay: nextReducer.getShowReplay(state, id),
    replayIndex: nextReducer.getReplayIndex(state, id),
    searchTimeline: nextReducer.getSearchTimeline(state, id),
    modelsSearchTimeline: nextModelsReducer.getSearchTimeline(state, id),

    replayInfo: nextReducer.getReplayInfo(state, id),
    isGuided: viewReducer.getIsGuided(state),
    optimized: optimized,

    selectedScenario: projectReducer.getSelectedScenario(state, projectId),
    allScenarios: projectReducer.getAllScenarios(state, projectId),
    approvedScenario: projectReducer.getApprovedScenario(state, projectId, runId),

    isContinuous: setupReducer.getIsContinuous(state, runId),
    expectedCountContinuous: setupReducer.getExpectedCountContinuous(state, runId),
    expectedValueContinuous: setupReducer.getExpectedValueContinuous(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),
    timePeriod: setupReducer.getTimePeriod(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(NextFooterContainer);
